import { isDefined as g } from "./node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { isVNode as u, Comment as m, Fragment as d } from "vue";
import { globalWidthBreakpoints as a, globalHeightBreakpoints as s } from "./constants.js";
const x = (e) => e.toUpperCase().replace("-", "").replace("_", ""), $ = !!(typeof window < "u" && window.document && window.document.createElement), b = (e) => e && typeof e == "object" && "$" in e && "$options" in e && "$root" in e && "$el" in e;
function E(e) {
  return e.replace(/([-_][a-z])/gi, x);
}
const N = (e) => e.charAt(0).toUpperCase() + e.slice(1);
function k(e, t) {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => e(r), t);
  };
}
function C(e) {
  if (Array.isArray(e)) {
    for (const t of e)
      if (u(t) && h(t.type))
        return t;
    for (const t of e)
      if (u(t) && t.type === d) {
        const n = C(t.children);
        if (n !== null)
          return n;
      }
  }
}
function h(e) {
  return e !== d && typeof e == "object" && !e.type;
}
function B(e, t) {
  if (Array.isArray(e)) {
    for (const n of e)
      if (!(!u(n) || n.type === m)) {
        if (n.type === d)
          return B(n.children, t);
        if (!t || t(n))
          return n;
      }
  }
}
function A(e) {
  return Array.isArray(e) ? e.filter((t) => u(t) && t.type !== m).map((t) => u(t) && t.type === d ? A(t.children) : t).flat() : [];
}
function S(e, t, n) {
  return Array.isArray(e) ? e.map((r, f) => !u(r) || r.type === m ? r : r.type === d ? (r.children = S(r.children, t, f + (n ?? 0)), r) : t(r, f + (n ?? 0))) : e;
}
function R(e) {
  const t = e.$el ? e.$el : e;
  return t.nodeType === Node.TEXT_NODE ? t.nextElementSibling : t;
}
function M(e, t, n) {
  if (!e || !t)
    return !1;
  const r = e.getBoundingClientRect(), f = t.getBoundingClientRect(), o = Math.floor(r.left), l = Math.floor(r.right), c = Math.floor(f.left), i = Math.floor(f.right), p = c >= o && i <= l, y = n && (c < o && i > o || i > l && c < l);
  return p || y;
}
function z(e, t, n) {
  return n || (n = `${t}s`), `${e || 0} ${e === 1 ? t : n}`;
}
function F(e, t) {
  const n = getComputedStyle(t), r = () => {
    let l = "";
    const c = {
      "50%": "ultra-condensed",
      "62.5%": "extra-condensed",
      "75%": "condensed",
      "87.5%": "semi-condensed",
      "100%": "normal",
      "112.5%": "semi-expanded",
      "125%": "expanded",
      "150%": "extra-expanded",
      "200%": "ultra-expanded"
    };
    let i;
    return n.fontStretch in c ? i = c[n.fontStretch] : i = "normal", l = n.fontStyle + " " + n.fontVariant + " " + n.fontWeight + " " + i + " " + n.fontSize + "/" + n.lineHeight + " " + n.fontFamily, l;
  }, o = document.createElement("canvas").getContext("2d");
  if (o === null)
    throw new Error("Unexpected null context");
  return o.font = n.font || r(), o.measureText(e).width;
}
function I(e, t) {
  return e.replace(/\${(.*?)}/g, (n, r) => t[r] || "");
}
function U(e) {
  return g(e) && typeof e == "object" && !Array.isArray(e);
}
const _ = (e) => e >= a["2xl"] ? "2xl" : e >= a.xl ? "xl" : e >= a.lg ? "lg" : e >= a.md ? "md" : e >= a.sm ? "sm" : "default", j = (e) => e >= s["2xl"] ? "2xl" : e >= s.xl ? "xl" : e >= s.lg ? "lg" : e >= s.md ? "md" : e >= s.sm ? "sm" : "default";
export {
  $ as canUseDOM,
  k as debounce,
  R as domFromRef,
  I as fillTemplate,
  A as findChildrenVNodes,
  C as findComponentVNode,
  B as findFirstChildVNode,
  _ as getBreakpoint,
  F as getTextWidth,
  j as getVerticalBreakpoint,
  b as isComponentPublicInstance,
  M as isElementInView,
  U as isRawSlots,
  z as pluralize,
  E as toCamelCase,
  N as ucfirst,
  h as vnodeTypeIsComponent,
  S as walkChildrenVNodes
};
